import { render, staticRenderFns } from "./UploadExcel.vue?vue&type=template&id=e2d80a32&scoped=true&"
import script from "./UploadExcel.vue?vue&type=script&lang=js&"
export * from "./UploadExcel.vue?vue&type=script&lang=js&"
import style0 from "./UploadExcel.vue?vue&type=style&index=0&id=e2d80a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d80a32",
  null
  
)

export default component.exports